import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardHomeComponent } from './home/dashboard-home.component';
import { DashboardComponent } from './dashboard.component';
import { AuthorizeGuard } from 'src/app/guards/authorize/authorize.guard';
import { UnitsComponent } from './units/units.component';
import { PayloadsComponent } from './payloads/payloads.component';
import { CustomerProfileComponent } from './home/customer/profile/profile.component';
import { NewAlertsComponent } from './home/new/newAlerts.component';
import { NewPreferencesComponent } from './home/new/newPreferences.component';
import { NewMeteringComponent } from './home/new/newMetering.component';
import { CustomerAlertsComponent } from './home/customer/alerts/alerts.component';
import { NewDashboardComponent } from './home/new/newDashboard.component';
import { HelpPageComponent } from './help/help-page.component';


const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    children: [
      { path: 'home', component: DashboardHomeComponent, canActivate: [AuthorizeGuard] },
      { path: 'profile', component: CustomerProfileComponent, canActivate: [AuthorizeGuard] },
      { path: 'customerAlerts', component: CustomerAlertsComponent, canActivate: [AuthorizeGuard] },
      { path: 'newAlerts', component: NewAlertsComponent, canActivate: [AuthorizeGuard] },
      { path: 'newDashboard', component: NewDashboardComponent, canActivate: [AuthorizeGuard] },
      { path: 'newMetering', component: NewMeteringComponent, canActivate: [AuthorizeGuard] },
      { path: 'newPreferences', component: NewPreferencesComponent, canActivate: [AuthorizeGuard] },
      { path: 'help', component: HelpPageComponent, canActivate: [AuthorizeGuard] },
      { path: 'distributors', loadChildren: () => import('./distributors/distributors.module').then(m => m.DistributorsModule) },
      { path: 'tanks', loadChildren: () => import('./tanks/tanks.module').then(m => m.TanksModule) },
      { path: 'tankGroups', loadChildren: () => import('./tankGroups/tankGroups.module').then(m => m.TankGroupsModule) },
      { path: 'branches', loadChildren: () => import('./branches/branches.module').then(m => m.BranchesModule) },
      { path: 'customers', loadChildren: () => import('./customers/customers.module').then(m => m.CustomersModule) },
      { path: 'employees', loadChildren: () => import('./employees/employees.module').then(m => m.EmployeesModule) },
      { path: 'payloads', loadChildren: () => import('./payloads/payloads.module').then(m => m.PayloadsModule) },
      { path: 'reports', loadChildren: () => import ('./reports/reports.module').then(m => m.ReportsModule) },
      { path: 'users', loadChildren: () => import('./users/users.module').then(m => m.UsersModule) },
      { path: 'virtualMetering', loadChildren: () => import('./virtualMetering/virtualMetering.module').then(m => m.VirtualMeteringModule) },
      { path: 'activateUsers', loadChildren: () => import('./users/users.module').then(m => m.UsersModule) },
      { path: 'units', loadChildren: () => import('./units/units.module').then(m => m.UnitsModule) },
      { path: 'deviceControl', loadChildren: () => import('./deviceControl/deviceControl.module').then(m => m.DeviceControlModule) },
      { path: 'alerts', loadChildren: () => import('./alerts/alerts.module').then(m => m.AlertsModule) },
      { path: 'workOrders', loadChildren: () => import('./workOrders/workOrders.module').then(m => m.WorkOrdersModule) },
      // { path: 'widgets', loadChildren: () => import('../../_template/widgets/widgets.module').then(m => m.WidgetsModule) },
      // { path: 'basic-ui', loadChildren: () => import('../../_template/basic-ui/basic-ui.module').then(m => m.BasicUiModule) },
      // { path: 'advanced-ui', loadChildren: () => import('../../_template/advanced-ui/advanced-ui.module').then(m => m.AdvancedUiModule) },
      // { path: 'charts', loadChildren: () => import('../../_template/charts/charts.module').then(m => m.ChartsDemoModule) },
      // { path: 'forms', loadChildren: () => import('../../_template/forms/form.module').then(m => m.FormModule) },
      // { path: 'editors', loadChildren: () => import('../../_template/editors/editors.module').then(m => m.EditorsModule) },
      // { path: 'tables', loadChildren: () => import('../../_template/tables/tables.module').then(m => m.TablesModule) },
      // { path: 'icons', loadChildren: () => import('../../_template/icons/icons.module').then(m => m.IconsModule) },
      // { path: 'maps', loadChildren: () => import('../../_template/maps/maps.module').then(m => m.MapsModule) },
      // { path: 'general-pages', loadChildren: () => import('../../_template/general-pages/general-pages.module').then(m => m.GeneralPagesModule) },
      // { path: 'ecommerce', loadChildren: () => import('../../_template/ecommerce/ecommerce.module').then(m => m.EcommerceModule) },
      // { path: 'apps', loadChildren: () => import('../../_template/apps/apps.module').then(m => m.AppsModule) },
      // { path: 'user-pages', loadChildren: () => import('../../_template/user-pages/user-pages.module').then(m => m.UserPagesModule) },
      // { path: 'error-pages', loadChildren: () => import('../../_template/error-pages/error-pages.module').then(m => m.ErrorPagesModule) },
    ]
  }
];


@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule
  ]
})
export class DashboardRoutingModule { }
